<template>
  <div class="w-full flex items-center justify-center">
    <div class="flex flex-col items-center justify-center w-full lg:w-3/4">
      <h2 class="mb-8">Automated Newsletter</h2>
      <p class="text-truegray-500 mb-4">
        The automated newsletter will be queued once a week on the day and time
        specified below. It will automatically include all posts created or
        pulled from the cloud from the previous 7 days when it is sent.
      </p>
      <FormulateForm v-model="form" class="w-full" @submit="onSubmit">
        <div class="mb-6 w-full flex items-center justify-center gap-4">
          <FormulateInput
            class="w-full lg:w-1/2"
            name="subject"
            label="Newsletter Subject"
            validation="required"
          />
          <FormulateInput
            class="w-full lg:w-1/2"
            name="title"
            label="Newsletter Title"
            validation="required"
          />
        </div>

        <div class="mb-4 w-full">
          <FormulateInput
            name="blurb"
            type="textarea"
            rows="2"
            label="Newsletter Blurb (optional)"
          />
        </div>
        <div class="mb-4 w-full">
          <FormulateInput
            name="mailLists"
            label="Mail list(s)"
            validation="required"
          >
            <template #label="context">
              <p class="text-sm">
                {{ context.label }}
              </p>
            </template>
            <template #element>
              <NewsletterListDropdown
                :label="'Send to'"
                :response-selection-id="'newQueuedAutoNewsletterMailLists'"
                :height="'12'"
              />
            </template>
          </FormulateInput>
        </div>
        <div class="mb-4 flex gap-4 w-full auto-newsletter">
          <FormulateInput
            class="w-1/2"
            name="day"
            type="select"
            label="Send Day"
            validation="required"
            :options="days"
          />
          <FormulateInput
            class="w-1/2"
            name="time"
            label="Send Time"
            validation="required"
          >
            <template #label="context">
              <p class="text-sm">
                {{ context.label }}
              </p>
            </template>
            <template #element>
              <date-picker
                v-model="form.time"
                format="hh:mm a"
                value-type="format"
                type="time"
                :minute-step="30"
              ></date-picker>
            </template>
          </FormulateInput>
        </div>
        <div class="mt-8 mb-4 w-full flex items-center justify-center">
          <FormulateInput
            type="submit"
            :disabled="isSubmitting"
            :input-class="['w-52 btn-cw-700']"
          >
            <span
              v-if="isSubmitting"
              class="w-full h-6 flex items-center justify-center"
            >
              <lottie :options="loadingAnimationOptions" />
            </span>
            <span v-else> Submit </span>
          </FormulateInput>
        </div>
      </FormulateForm>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted } from 'vue'
import { EventBus } from '../../../../../../js/plugins/event-bus.js'
import { useRoute } from 'vue-router/composables'
import { useStore } from '../../../../../../js/store/index.js'
import * as loadingAnimation from '../../../../../../shared/components/loading.json'
import DatePicker from 'vue2-datepicker'
import NewsletterListDropdown from '../NewsletterListDropdown.vue'

export default defineComponent({
  name: 'AutoNewsletterModal',

  components: {
    NewsletterListDropdown,
    DatePicker,
  },

  setup() {
    const store = useStore()
    const loadingAnimationOptions = { animationData: loadingAnimation.default }
    const isSubmitting = ref(false)

    const form = ref({
      title: '',
      subject: '',
      blurb: '',
      mailLists: [],
      day: 1,
      time: '',
    })

    const days = [
      {
        label: 'Monday',
        value: 1,
      },
      {
        label: 'Tuesday',
        value: 2,
      },
      {
        label: 'Wednesday',
        value: 3,
      },
      {
        label: 'Thursday',
        value: 4,
      },
      {
        label: 'Friday',
        value: 5,
      },
      {
        label: 'Saturday',
        value: 6,
      },
      {
        label: 'Sunday',
        value: 0,
      },
    ]

    const onSubmit = async () => {
      isSubmitting.value = true
      await store.dispatch('careerwise/dispatchUpdateAutoNewsletter', {
        payload: form.value,
      })
      isSubmitting.value = false
      EventBus.$emit('showModal', null)
      EventBus.$emit('autoNewsletterStatusChanged')
    }

    onMounted(() => {
      EventBus.$on('newQueuedAutoNewsletterMailLists', (selected) => {
        form.value.mailLists = selected.selectedIds
      })
    })

    return { loadingAnimationOptions, isSubmitting, form, days, onSubmit }
  },
})
</script>

<style>
.auto-newsletter .mx-datepicker .mx-input-wrapper .mx-input {
  height: 45px;
  margin-top: 4px;
}
.auto-newsletter .mx-datepicker {
  width: 100%;
}
</style>
